import { render, staticRenderFns } from "./fieldset.vue?vue&type=template&id=08cd82a4&scoped=true&"
import script from "./fieldset.vue?vue&type=script&lang=js&"
export * from "./fieldset.vue?vue&type=script&lang=js&"
import style0 from "./fieldset.vue?vue&type=style&index=0&id=08cd82a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd82a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('08cd82a4', component.options)
    } else {
      api.reload('08cd82a4', component.options)
    }
    module.hot.accept("./fieldset.vue?vue&type=template&id=08cd82a4&scoped=true&", function () {
      api.rerender('08cd82a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/fieldset.vue"
export default component.exports